import m from "../../geodata/es2015/colombiaMuniLow";
window.am4geodata_colombiaMuniLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/colombiaMuniLow.js
// module id = null
// module chunks = 